import { padStart } from 'lodash'

export const getKey = (t: [number, number]) => {
  return `${padStart(t?.[0]?.toString(), 2, '0')}${padStart(t?.[1]?.toString(), 2, '0')}`
}
